import React from "react";
import ReactMarkdown from "react-markdown";
import { useSelector } from "react-redux";

import { ColorTestPilot } from "@intelligems/ig-theme";
import { Avatar, Box, Divider, Grid } from "@mui/material";

import { KimcheeStandingPose } from "../../../../../images/KimcheeStandingPose";
import { experienceAnalysis } from "../../../../../store/slices/ai";

export const Messages = ({ name }: { name: string }) => {
  const analysis = useSelector(experienceAnalysis);
  return analysis.messages.map((message, index) => (
    <>
      <Grid
        container
        item
        key={message.id}
        flexWrap={"nowrap"}
        columnSpacing={2}
      >
        <Grid item sx={{ minWidth: "70px", paddingTop: "10px" }}>
          {message.role === "assistant" ? (
            <KimcheeStandingPose
              sx={{
                marginLeft: "0px",
                width: "60px",
                height: "60px",
              }}
            />
          ) : (
            <Avatar
              variant={"rounded"}
              sx={{ bgcolor: ColorTestPilot.blue, marginLeft: "10px" }}
            >
              {name}
            </Avatar>
          )}
        </Grid>
        <Grid item>
          <Box className={"ai-markdown"}>
            <ReactMarkdown children={message.message || ""} />
          </Box>
        </Grid>
      </Grid>
      {index < analysis.messages.length - 1 ? (
        <Divider sx={{ width: "100%", height: "4px" }} />
      ) : null}
    </>
  ));
};
